import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../ui/TextField";
import DataSelect from "../../../../../ui/DataSelect";
import Checkbox from "../../../../../ui/Checkbox";
import useOrganizationForm from "../../../../hooks/useOrganizationForm";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getDictLegalForms} from "../../../../../Dict/store/actions";

const defaultData = {
  name: "",
  buildingId: null,
  roomType: null,
  depId: null,
  area: null,
  capacity: null,
  number: "",
  note: "",
  demo: false,
  limiting: "",
  specialities: [],
  worldSkills: [],
  customer : false,
  employer : false,
  contractor : false,
  status: 1,
  legalForm: null
};

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  headingNoMargin: {
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  heading: {
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "25px 0 15px 0"
  },
  block: {},
  avatarContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& > span": {
      marginLeft: 10
    }
  }
});

const STATUS_CODES = [
  {
    id: 0,
    name: "Ликвидирована"
  },
  {
    id: 1,
    name: "Действует"
  },
  {
    id: 2,
    name: "В стадии ликвидации"
  },
  {
    id: 3,
    name: "В стадии банкротства"
  }
];

const OrganizationsForm = ({
  disabled,
  onFormChange,
  initialData,
  classes,
  editmode, legalFormList, getDictLegalForms
}) => {
  const [data, setData] = React.useState(initialData || defaultData);

  const {
    dataSources: selectData,
    getOrganizationForm
  } = useOrganizationForm();

  useEffect(() => {
    getOrganizationForm();
    getDictLegalForms();
  }, []);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.headingNoMargin}>
        Основные сведения
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                value={data.name || ""}
                onChange={e => onChange("name", e.target.value)}
                label="Полное наименование"
                disabled={disabled}
                required
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              {legalFormList &&
              <DataSelect
                value={data.legalForm}
                onChange={value => onChange("legalForm", value._key)}
                label="ОПФ"
                dataSource={legalFormList}
                disabled={disabled || !editmode}
                keyField="_key"
              />}
            </Grid>
            <Grid item xs={6}>
              <DataSelect
                value={data.status}
                onChange={value => onChange("status", value.id)}
                label="Статус"
                dataSource={STATUS_CODES}
                disabled={disabled || !editmode}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                value={data.ogrn || ""}
                onChange={e => onChange("ogrn", e.target.value)}
                label="ОГРН/ОГРНИП"
                placeholder="XXXXXXXXXXXXXXX"
                disabled={disabled}
                required
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={data.inn || ""}
                onChange={e => onChange("inn", e.target.value)}
                label="ИНН"
                placeholder="XXXXXXXXXXXX"
                disabled={disabled}
                required
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextField
                value={data.okogu || ""}
                onChange={e => onChange("okogu", e.target.value)}
                label="ОКОГУ"
                placeholder="XXXXXXX"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                value={data.okopf || ""}
                onChange={e => onChange("okopf", e.target.value)}
                label="ОКОПФ"
                placeholder="XXXXX"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                value={data.okfs || ""}
                onChange={e => onChange("okfs", e.target.value)}
                label="ОКФС"
                placeholder="XX"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                value={data.okved || ""}
                onChange={e => onChange("okved", e.target.value)}
                label="ОКВЭД"
                placeholder="XX.XX.XX"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                value={data.shortName || ""}
                onChange={e => onChange("shortName", e.target.value)}
                label="Краткое наименование"
                disabled={disabled}
                required
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={data.abbr || ""}
                onChange={e => onChange("abbr", e.target.value)}
                label="Аббревиатура"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                value={data.ogrnDate || ""}
                onChange={e => onChange("ogrnDate", e.target.value)}
                label="Дата регистрации"
                disabled={disabled}
                type="date"
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={data.ogrnOrgan || ""}
                onChange={e => onChange("ogrnOrgan", e.target.value)}
                label="Регистрирующий орган"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                value={data.kpp || ""}
                onChange={e => onChange("kpp", e.target.value)}
                label="КПП"
                placeholder="XXXXXXXXXXXX"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={data.okpo || ""}
                onChange={e => onChange("okpo", e.target.value)}
                label="ОКПО"
                placeholder="XXXXXXXXXX"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                value={data.okveds || ""}
                onChange={e => onChange("okveds", e.target.value)}
                label="Дополнительные ОКВЕД"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Typography className={classes.heading}>Контактная информация</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                value={data.phones || ""}
                onChange={e => onChange("phones", e.target.value)}
                label="Контактные телефоны"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={data.fax || ""}
                onChange={e => onChange("fax", e.target.value)}
                label="Факс"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                required
                value={data.email || ""}
                onChange={e => onChange("email", e.target.value)}
                label="E-mail"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={data.siteUrl || ""}
                onChange={e => onChange("siteUrl", e.target.value)}
                label="Веб-сайт"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
            <TextField
              value={data.contactPerson || ""}
              onChange={e => onChange("contactPerson", e.target.value)}
              label="Контактное лицо"
              disabled={disabled}
              readOnly={!editmode}
            />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Typography className={classes.heading}>
        Образовательная деятельность
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={6} md={3}>
          <div className={classes.block}>
            <Checkbox label="Главный ЦОПП региона" checked={data.coppAdmin || false}
                      onChange={event => onChange("coppAdmin", event.target.checked)}
                      disabled={!editmode} />
          </div>
        </Grid>
        <Grid item xs={6} md={3}>
          <div className={classes.block}>
            <Checkbox label="Цифровой колледж" checked={data.college || false}
                      onChange={event => onChange("college", event.target.checked)}
                      disabled={!editmode} />
          </div>
        </Grid>
        <Grid item xs={12} md={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                value={data.collegeInfo || ""}
                onChange={e => onChange("collegeInfo", e.target.value)}
                label="Данные о регистрации в ИТП Цифровой колледж"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Typography className={classes.heading}>Статус организации в системе</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Checkbox label="Подрядчик" checked={data.contractor || false}
                    onChange={event => onChange("contractor", event.target.checked)}
                    disabled={disabled} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Checkbox label="Заказчик" checked={data.customer || false}
                    onChange={event => onChange("customer", event.target.checked)}
                    disabled={disabled} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Checkbox label="Работодатель" checked={data.employer || false}
                    onChange={event => onChange("employer", event.target.checked)}
                    disabled={disabled} />
        </Grid>
      </Grid>

      <Typography className={classes.heading}>Адреса</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                required
                value={data.legalAddress || ""}
                onChange={e => onChange("siteUrl", e.target.value)}
                label="Юридический адрес"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={data.postAddress || ""}
                onChange={e => onChange("postAddress", e.target.value)}
                label="Почтовый адрес"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DataSelect
                value={data.region}
                onChange={value => onChange("region", value.id)}
                label="Регион"
                dataSource={selectData.regions}
                disabled={disabled || !editmode}
              />
            </Grid>
            <Grid item xs={12}>
              <DataSelect
                value={data.municipal}
                onChange={value => onChange("municipal", value.id)}
                label="Муниципальное образование"
                dataSource={selectData.municipals}
                disabled={disabled || !editmode}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  legalFormList: state.dictAll.legalFormList,
});

const mapDispatchToProps = dispatch => ({
  getDictLegalForms: () => dispatch(getDictLegalForms()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles)(OrganizationsForm)));
